import { Table } from "@/features/Table";
import { type LinkType, links_columns } from "./columns";
import { FilterLinks, type FilterLinksSchema } from "./filter";
import { CLIENT, TABLE_NAME } from "./config";

const client = CLIENT;
const table_name = TABLE_NAME;

export const LinksTable = () => {
  return (
    <Table<LinkType, FilterLinksSchema>
      label="Portfolio Link"
      client={client}
      table_name={table_name}
      columns={links_columns}
      filter={<FilterLinks table_name={table_name} />}
      disable_translations_request={true}
    />
  );
};
